import React from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
import BookingList from '../Pages/BookingList'
import BookingView from '../Pages/BookingView'
import AddBooking from '../Pages/AddBooking'
import BookingEdit from '../Pages/BookingEdit'

function BookingEventsRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/booking-events'
        render={() => (
          <React.Fragment>
            <BookingList history={history} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/booking/view/:slack'
        render={(props) => (
          <React.Fragment>
            <BookingView {...props} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/add'
        render={(props) => (
          <React.Fragment>
            <AddBooking {...props} />
          </React.Fragment>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/booking/edit/:slack'
        render={(props) => (
          <React.Fragment>
            <BookingEdit {...props} />
          </React.Fragment>
        )}
      />
      <Route
        path='/:lng/booking-events/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(BookingEventsRoute)
